"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _theme = require("../theme");

var _core = require("@emotion/core");

function fontfaces(_ref) {
  var fontVariants = _ref.fontVariants;
  var fonts = [];

  if (typeof fontVariants === 'function') {
    fonts = fontVariants();
  } else if (Array.isArray(fontVariants)) {
    fonts = fontVariants;
  }

  return fonts;
}

function bodyStyles(theme) {
  if (!theme.font) {
    return;
  }

  return {
    body: {
      fontFamily: theme.font.body,
      fontWeight: theme.weights.regular
    }
  };
} // eslint-disable-next-line valid-jsdoc

/** @component */


function GlobalFontFace() {
  var theme = (0, _theme.useTheme)();
  var fontFaces = fontfaces(theme);
  var body = bodyStyles(theme);
  return (0, _core.jsx)(_react.default.Fragment, null, fontFaces.map(function (font) {
    if (!font) {
      return null;
    }

    return (0, _core.jsx)(_theme.Global, {
      key: "".concat(font.family, "-").concat(font.weight),
      styles: {
        '@font-face': {
          fontFamily: font.family,
          src: "url('".concat(font.url, "') format('").concat(font.format, "')"),
          // The fontWeight type for font-face is incorrect. Reference multiple values: https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-weight#syntax
          // This should use FontFaceFontWeightProperty (string | number) which supports multiple values (font-weight: normal medium bold;)
          // NOT FontWeightProperty (bold | bolder | number, etc) which only supports a single value (font-weight: bold;).
          // Revist when we upgrade emotion from v10 or cssType.
          fontWeight: font.weight
        },
        body: {
          fontVariantLigatures: 'no-contextual'
        }
      }
    });
  }), body && (0, _core.jsx)(_theme.Global, {
    styles: body
  }));
}

var _default = GlobalFontFace;
exports.default = _default;